import { API_URL } from "shared";

export const getImageUrl = (id, width) => {
  const widthString = width ? `?width=${width}` : "";
  return `${API_URL}/img/${id}` + widthString
};
